
export enum MergeUnitClientBankAccountType {
    None = 0,
    ExternalAccount = 1,
    CovercyAccount = 2
}

export namespace MergeUnitClientBankAccountType {
    export function toString(accountType: MergeUnitClientBankAccountType): string {
        switch (accountType) {
            case MergeUnitClientBankAccountType.None:
                return 'N/A';
            case MergeUnitClientBankAccountType.ExternalAccount:
                return 'External Account';
            case MergeUnitClientBankAccountType.CovercyAccount:
                return 'Covercy Account';
            default:
                return null;
        }
    }

    export function listAll() {
        return [MergeUnitClientBankAccountType.ExternalAccount, MergeUnitClientBankAccountType.CovercyAccount];
    }

    export function parse(accountType: string): MergeUnitClientBankAccountType {
        return MergeUnitClientBankAccountType[accountType];
    }
}

export default MergeUnitClientBankAccountType;